export const VIMEO_PLAYER_BASE_URL = 'https://player.vimeo.com/video'
